import React from 'react';
import { Button } from '@material-ui/core';

class ConfirmButton extends React.Component {
  render() {
    return (
      <Button
        // color={this.props.color}
        // color={this.props.theme.palette.primary.main}
        style={{
          fontSize: '1.2em',
          color: '#fff',
          backgroundColor: '#237a9d',
        }}
        size="large"
        variant="contained"
        disableElevation
        {...this.props}
      >
        {this.props.children}
      </Button>
    );
  }
}

export default ConfirmButton;
